import { z } from "zod";
import { config } from "../../config";
import { trackEventPayloadZod } from "../types";

export const rudderStackClientEventZod = z.object({
  event: z.object({
    tracing_id: z.string(),
    type: z.string().regex(/^com\.sinch\./),
    source: z.literal("com.sinch.frameworks"),
    action: trackEventPayloadZod.shape.action.optional(),
    target: trackEventPayloadZod.shape.target.optional(),
    name: z.string(),
    unformatted_name: z.string(),
    display_name: z.string(),
    tag_version: z.string().optional(),
    timestamp: z.number(),
    session_id: z.string(),
    description: z.string(),
  }),
  user: z.object({
    id: z.string(),
    type: z.union([
      z.literal("N"),
      z.literal("L"),
      z.literal("S"),
      z.literal(""),
    ]),
    email: z.union([z.string().min(1), z.null()]),
    anonymous_id: z.string().min(1),
    country: z.string().min(1),
    language: z.string(),
    role: z.array(z.string()),
    timezone: z.string(),
    created_at: z.string(),
    has_phone_in_profile: z.boolean().nullable(),
    is_super_user: z.boolean().nullable(),
    is_smoke_tester: z.boolean().nullable(),
  }),
  account: z.object({
    id: z.union([z.string().min(1), z.null()]),
    billing_type: z.string(),
    payment_type: z.string(),
    vendor_id: z.union([z.string().min(1), z.null()]),
    country: z.union([z.string().min(1), z.null()]),
    verification_status: z.string(),
    currency: z.string(),
    has_2fa_Enabled: z.boolean().nullable(),
    first_product: z.string(),
    focus_area: z.string(),
    status: z.string(),
    type: z.string(),
    created_at: z.string(),
  }),
  device: z.object({
    type: z.string(),
    viewport_size: z.string().regex(/^\d+x\d+$/),
    os: z.string(),
    browser: z.string(),
    browser_version: z.string(),
    user_agent: z.string(),
  }),
  app: z.object({
    name: z.string(),
    module: z.string(),
    env: z.string(),
    region: z
      .union([
        z.literal("emea"),
        z.literal("apac"),
        z.literal("latam"),
        z.literal("na"),
      ])
      .default(() =>
        config.SHELL_ENV.CONFIG_NAME.split(".")[0] === "dashboard"
          ? "emea"
          : "apac"
      ),
    vendor_id: z.string().min(1),
  }),
  page: z.object({
    url: z.string(),
    prev_url: z.string(),
  }),
  experiment: z.object({
    name: z.string(),
    bucket: z.string(),
  }),
  custom: z.record(z.any()).optional(),
});

export type RudderStackClientEvent = z.infer<typeof rudderStackClientEventZod>;
